/**
 * Review Modal Scroll Lock & Overlay Close JS
 * Locks scroll when Judge.me review popup is open without shifting page position, and closes modal on overlay click
 */
(function() {
  var isLocked = false;

  function preventScroll(e) {
    // Only allow scrolling inside the modal form content box, prevent on overlay background
    var isInsideForm = e.target.closest('.jdgm-write-review-modal__content, .jdgm-form, .jdgm-modal-content');
    if (!isInsideForm) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  }

  function checkReviewModalState() {
    // Targets exact Judge.me modal classes: .jdgm-review-widget-modal & .jdgm-write-review-modal
    var modal = document.querySelector('.jdgm-review-widget-modal, .jdgm-write-review-modal, .jdgm-write-rev-modal');
    var isOpen = false;

    if (modal) {
      var style = window.getComputedStyle(modal);
      // Modal is open when display is not none and visibility is not hidden
      if (style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0') {
        isOpen = true;
      }
    }

    if (isOpen && !isLocked) {
      isLocked = true;
      
      document.body.classList.add('jdgm-modal-open-lock');
      document.documentElement.classList.add('jdgm-modal-open-lock');

      window.addEventListener('wheel', preventScroll, { passive: false });
      window.addEventListener('touchmove', preventScroll, { passive: false });
    } else if (!isOpen && isLocked) {
      isLocked = false;
      
      document.body.classList.remove('jdgm-modal-open-lock');
      document.documentElement.classList.remove('jdgm-modal-open-lock');

      window.removeEventListener('wheel', preventScroll);
      window.removeEventListener('touchmove', preventScroll);
    }
  }

  var observer = new MutationObserver(function() {
    checkReviewModalState();
  });

  document.addEventListener('DOMContentLoaded', function() {
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });

    // Close modal when clicking on the dark overlay background
    document.addEventListener('click', function(e) {
      var overlay = e.target.closest('.jdgm-write-review-modal__overlay, .jdgm-rev-widg__modal-overlay');
      var modal = document.querySelector('.jdgm-review-widget-modal, .jdgm-write-review-modal, .jdgm-write-rev-modal');
      var innerCard = e.target.closest('.jdgm-write-review-modal__content, .jdgm-form, .jdgm-modal-content');

      if (overlay || (modal && modal.contains(e.target) && !innerCard)) {
        var closeBtn = modal.querySelector('.jdgm-write-review-modal__close, .jdgm-close-icon, [aria-label="Close"], .jdgm-modal-close');
        if (closeBtn) {
          closeBtn.click();
        } else {
          modal.style.display = 'none';
        }
      }
      setTimeout(checkReviewModalState, 100);
    });
  });
})();
    